// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"351":"8b6864c6","578":"f23eb669","956":"b3391809"}[chunkId] + ".chunk.js";
};